export const HEADER_HEIGHT_CSS_VAR = '--header-height';

export function headerHeightVar(fallbackPx: number) {
  return `var(${HEADER_HEIGHT_CSS_VAR}, ${fallbackPx}px)`;
}

export const HEADER_HEIGHT_XS_SM = 124;
export const HEADER_HEIGHT_MD_LG_XL = 139;

export const GLOBAL_NAV_HEIGHT = 133;

export const MINIMAL_HEADER_HEIGHT_XS = 80;
export const MINIMAL_HEADER_HEIGHT_LG = 96;

export const LEGACY_HEADER_HEIGHT = 100;
